module.exports = __webpack_public_path__ + "static/media/atom_small.ebfa6451.png";